import React from "react";
import { cn } from "@/lib/utils";
import { KeyFinancialTabValue } from "./bar-chart-annual-quarterly-mobile";
import { Card } from "@/components/ui/card";
import { periodMappings } from "@/app/interface/global";

export interface Props {
    returnsData: { label: string; value: number }[];
    activeTab: KeyFinancialTabValue;
}

function DayPerformance({ value, isPositive }: { value: number; isPositive: boolean }) {
    return (
        <span className={cn("flex items-center justify-end gap-0.5 text-sm")}>
            <span className="font-normal tracking-wide text-black">{value}%</span>
            <span className="text-xs leading-none">{isPositive ? "▲" : "▼"}</span>
        </span>
    );
}

const ReturnsTable: React.FC<Props> = ({ returnsData, activeTab }) => {
    return (
        <div className="mb-6 mt-6 w-full max-w-full">
            <Card className="min-h-[322px] rounded-xl py-5">
                <div className="relative mb-2 flex items-center justify-between border-0 border-[#0E0F171A] px-4">
                    <h3 className="text-xl font-semibold">{activeTab}</h3>
                </div>
                <div className="px-4">
                    <table className="w-full border-collapse">
                        <tbody>
                            {returnsData.map((item, index) => {
                                const isPositive = item.value >= 0;

                                return (
                                    <tr
                                        key={index}
                                        className={`${index + 1 !== returnsData.length ? "border-b" : ""} border-gray-200`}
                                    >
                                        <td className="py-3 text-sm font-medium text-[#0F1016]">
                                            {periodMappings
                                                .find((period) => period.key === item.label)
                                                ?.textFull?.toLowerCase()}
                                        </td>

                                        <td className="py-3 text-right">
                                            <div
                                                className={`mr-4 inline-flex items-center gap-1 font-medium ${
                                                    isPositive ? "text-green-600" : "text-red-500"
                                                }`}
                                            >
                                                <div className="flex-shrink-0 text-right">
                                                    <DayPerformance
                                                        value={item.value}
                                                        isPositive={isPositive}
                                                    />
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            </Card>
        </div>
    );
};

export default ReturnsTable;
